import { useDispatch } from 'react-redux'

import { useLocation } from 'react-router-dom'
import { useCallback } from 'react'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { useIsDashboardOpen } from 'builder/hooks/useIsDashboardOpen'
import { actions as uiActions, selectors as uiSelectors } from 'builder/modules/ui'
import { useFeaturesConfig } from 'builder/hooks/featureConfig/useFeaturesConfig'
import { useUser } from 'builder/hooks/useUser'
import { actions as userAction } from 'builder/modules/user'
import { actions as panelAction } from 'builder/modules/panel'

const MODAL_SHOWN_STORAGE_KEY = 'rd-auto-apply-dual-modal'
export const DUAL_MODAL_FROM_DOWNLOAD_RESUME = 'DUAL_MODAL_FROM_DOWNLOAD_RESUME'

export const useAutoApplyResumeDistributionModal = () => {
  const dispatch = useDispatch()
  const isDashboard = useIsDashboardOpen()
  const isOpen = useTypedSelector(uiSelectors.isAutoApplyResumeDistributionModalOpen)
  const { features } = useFeaturesConfig()
  const isInSupportedRegion = ['US', 'GB'].includes(features.geoipCode)
  const { pathname } = useLocation()
  const user = useUser()
  const uiStates = user?.uiStates

  const closeModal = () => {
    localStorage.setItem(MODAL_SHOWN_STORAGE_KEY, 'true')
    dispatch(uiActions.toggleAutoApplyResumeDistributionModal(false))
  }

  const triggerModalOnDashboard = useCallback(() => {
    localStorage.setItem(DUAL_MODAL_FROM_DOWNLOAD_RESUME, 'true')
    if (!isInSupportedRegion && pathname === '/' && !uiStates?.welcomeModalSeen) {
      dispatch(panelAction.setUIStatesConfigStatus({ welcome_modal_seen: true }))
      dispatch(userAction.setUIUserState({ welcomeModalSeen: true }))
    }
  }, [uiStates?.welcomeModalSeen, isInSupportedRegion, pathname])

  return {
    isOpen: isOpen && !!isDashboard,
    planName: '20_credits_autoapply',
    isInSupportedRegion,
    closeModal,
    triggerModalOnDashboard,
  }
}
